/* eslint-disable react-refresh/only-export-components -- icon registry, not a component module */
import { type JSX, type SVGProps } from 'react';

type CustomIconProps = {
  size?: number;
  strokeWidth?: number;
} & SVGProps<SVGSVGElement>;

const DEFAULT_SIZE = 18;

const SparkleCircleIcon = ({
  size = DEFAULT_SIZE,
  strokeWidth = 1.75,
  ...rest
}: CustomIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
    {...rest}
  >
    <circle cx="12" cy="12" r="10" />
    <path
      d="M12 6.7 13.24 10.3 17.04 10.36 14 12.65 15.12 16.29 12 14.1 8.88 16.29 10 12.65 6.96 10.36 10.76 10.3Z"
      fill="currentColor"
      stroke="none"
    />
  </svg>
);

const SIGNAL_BARS = [
  { x: 2.5, y: 14, height: 7 },
  { x: 7.8, y: 10, height: 11 },
  { x: 13.1, y: 6, height: 15 },
  { x: 18.4, y: 2, height: 19 },
] as const;

const SignalBarsIcon = ({
  size = DEFAULT_SIZE,
  filledBars,
  ...rest
}: CustomIconProps & { filledBars: 1 | 2 | 3 | 4 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    aria-hidden
    {...rest}
  >
    {SIGNAL_BARS.map((bar, index) => (
      <rect
        key={bar.x}
        x={bar.x}
        y={bar.y}
        width={3.1}
        height={bar.height}
        rx={1}
        fill="currentColor"
        stroke="none"
        opacity={index < filledBars ? 1 : 0.24}
      />
    ))}
  </svg>
);

export type CustomIconComponent = (props: CustomIconProps) => JSX.Element;

const SignalBars1Icon = (props: CustomIconProps) => (
  <SignalBarsIcon {...props} filledBars={1} />
);
const SignalBars3Icon = (props: CustomIconProps) => (
  <SignalBarsIcon {...props} filledBars={3} />
);

export const CUSTOM_ICONS: Record<string, CustomIconComponent> = {
  'sparkle-circle': SparkleCircleIcon,
  'signal-bars-1': SignalBars1Icon,
  'signal-bars-3': SignalBars3Icon,
};

export const resolveCustomIcon = (name?: string): CustomIconComponent | undefined =>
  name ? CUSTOM_ICONS[name] : undefined;
